"use strict";
// import React, { useEffect } from 'react'
// import BootstrapTable from "react-bootstrap-table-next";
// import { CustomPagination } from "../../../Common/CustomPagination";
// import Dropdown from "react-bootstrap/Dropdown";
// import { BsThreeDots } from 'react-icons/bs';
// import { UseArchiveSOSRemorquage, useGetSOSRemorquageListQuery, UseTreateSOSRemorquage } from '../../../../utils/api/sos-remorquage/sos-remorquage.api';
// import { formatDate, formatDateWithRelativeDay } from '../../../../utils/Utils';
// import TableSkeleton from '../../AdminShared/TableSkeleton';
// import EmptyAlert from '../../../Shared/Alerts/EmptyAlert';
// import { NavLink } from 'react-router-dom';
// import { SOSRemorquage } from '../../../../utils/api/sos-remorquage/sos-remorquage.type';
// import useSocket from '../../../../hooks/useWebSocket';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArchiveButton = exports.TreatedButton = void 0;
// export const TreatedButton = ({ id }: { id: string }) => {
//     const treateSOSRemorquage = UseTreateSOSRemorquage(id);
//     return (
//         <button
//             className="dropdown-item"
//             onClick={() => treateSOSRemorquage()}
//             style={{
//                 background: 'none',
//                 border: 'none',
//                 width: '100%',
//                 textAlign: 'left',
//                 padding: '0.25rem 1.5rem'
//             }}
//         >
//             Traiter
//         </button>
//     );
// }
// export const ArchiveButton = ({ id }: { id: string }) => {
//     const archiveSOSRemorquage = UseArchiveSOSRemorquage(id);
//     return (
//         <button
//             className="dropdown-item"
//             onClick={() => archiveSOSRemorquage()}
//             style={{
//                 background: 'none',
//                 border: 'none',
//                 width: '100%',
//                 textAlign: 'left',
//                 padding: '0.25rem 1.5rem'
//             }}
//         >
//             Archiver
//         </button>
//     );
// }
// const SosRemorquagesAdminTable = ({ search, dateRange }: { search: string, dateRange: string }) => {
//     const socket = useSocket();
//     const [page, setPage] = React.useState(1);
//     const [perPage, setPerPage] = React.useState(10);
//     const { data, isLoading, refetch } = useGetSOSRemorquageListQuery({
//         page: page,
//         limit: perPage,
//         word: search,
//         date: dateRange,
//     });
//     const statutFormatter = (cell: string, row: any) => {
//         return (
//             <div className="statutformatter__wrapper">
//                 {/* {cell === "traited" ? (
//                     <div className="badge custom-badge-success">
//                         Traité
//                     </div>
//                 ) : (
//                     <div className="badge custom-badge-in-progress">
//                         Nouveau
//                     </div>
//                 )} */}
//                 {row?.status === "traited" ? (
//                     <div className="badge custom-badge-success">
//                         Traité
//                     </div>
//                 ) : (row?.is_archive === 1) ? (
//                     <div className="badge bg-danger custom-badge-in-progress" style={{color: "#ffffff"}}>
//                         Archivé
//                     </div>
//                 ) : (row?.is_read === 1) ? (
//                     <div className="badge bg-warning custom-badge-in-progress" style={{color: "#ffffff"}}>
//                         Vu
//                     </div>
//                 ) : (
//                     <div className="badge custom-badge-in-progress">
//                         Nouveau
//                     </div>
//                 )}
//             </div>
//         );
//     };
//     const dateFormatter = (cell: string, row: any) => {
//         return (
//             <div className="statutformatter__wrapper position-relative">
//                 {formatDateWithRelativeDay(cell)}
//                 {(row?.status === "nouveau" && row?.is_archive === 0)&& (
//                     <div className="custon-date-indicator"></div>
//                 )}
//             </div>
//         );
//     };
//     const actionFormatter = (cell: string, row: SOSRemorquage) => {
//         return (
//             <div className="actionformatter__wrapper">
//                 <Dropdown>
//                     <Dropdown.Toggle id="dropdown-basic">
//                         <BsThreeDots />
//                     </Dropdown.Toggle>
//                     <Dropdown.Menu>
//                         <TreatedButton id={row.id} />
//                         <ArchiveButton id={row.id} />
//                         <NavLink
//                             className="dropdown-item"
//                             style={{
//                                 background: 'none',
//                                 border: 'none',
//                                 width: '100%',
//                                 textAlign: 'left',
//                                 padding: '0.25rem 1.5rem'
//                             }}
//                             to={`/admin/sos-remorquage/${row?.slug}`}
//                         >
//                             Voir détails
//                         </NavLink>
//                     </Dropdown.Menu>
//                 </Dropdown>
//             </div>
//         );
//     };
//     const positionFormatter = (cell:any, row:any) => {
//         const googleMapsUrl = `https://www.google.com/maps?q=${row?.lat},${row?.long}`;
//         return (
//             <a 
//                 href={googleMapsUrl} 
//                 target="_blank" 
//                 rel="noopener noreferrer"
//                 className="follow-position-link badge bg-success"
//                 style={{
//                     color: "#FFFFFF"
//                 }}
//             >
//                 Suivre la position
//             </a>
//         )
//     }
//     const columns = [
//         {
//             dataField: "request_datetime",
//             text: "Date de la demande",
//             formatter: dateFormatter,
//             headerStyle: () => {
//                 return {
//                     width: "300px",
//                     whiteSpace: "normal",
//                     textAlign: "start",
//                 };
//             },
//         },
//         {
//             dataField: "phone",
//             text: "NUMÉRO DE TÉLÉPHONE",
//             headerStyle: () => {
//                 return {
//                     width: "200px",
//                     whiteSpace: "normal",
//                     textAlign: "start",
//                 };
//             },
//         },
//         {
//             dataField: "lat",
//             text: "Position",
//             headerStyle: () => {
//                 return {
//                     width: "300px",
//                     whiteSpace: "normal",
//                     textAlign: "start",
//                 };
//             },
//             formatter: positionFormatter
//         },
//         {
//             dataField: "status",
//             text: "Statut",
//             formatter: statutFormatter,
//             headerStyle: () => {
//                 return {
//                     width: "200px",
//                     whiteSpace: "normal",
//                     textAlign: "start",
//                 };
//             },
//         },
//         {
//             dataField: "id",
//             text: "Action",
//             formatter: actionFormatter,
//             headerStyle: () => {
//                 return {
//                     width: "150px",
//                     whiteSpace: "normal",
//                     textAlign: "start",
//                 };
//             },
//         },
//     ];
//     useEffect(() => {
//         if (!socket) return;
//         console.log('Initializing socket listeners...');
//         socket.emit('join', 'remorquage');
//         // Version corrigée du listener
//         const newRemorquageHandler = (data: any) => {
//             console.log('Received new remorquage:', data);
//             refetch();
//         };
//         socket.on('new.remorquage', newRemorquageHandler);
//         // Nettoyage
//         return () => {
//             console.log('Cleaning up socket listeners...');
//             socket.off('new.remorquage', newRemorquageHandler);
//             socket.emit('leave', 'remorquage');
//         };
//     }, [socket, refetch]);
//     return (
//         <div className="col-lg-12">
//             <div className="admin-table">
//                 {!!isLoading && <TableSkeleton headers={columns} />}
//                 {!isLoading && (
//                     <>
//                         <BootstrapTable
//                             keyField="id"
//                             data={data?.data || []}
//                             columns={columns as any}
//                             condensed
//                             hover
//                             wrapperClasses="table-responsive admin-table"
//                             noDataIndication={() => (
//                                 <EmptyAlert textualContent="Aucune données trouvées" />
//                             )}
//                         />
//                         <div className="custom-pagination-container">
//                             <CustomPagination
//                                 nbPages={data?.count}
//                                 page={page}
//                                 onChange={(page, perPage) => {
//                                     setPerPage(perPage);
//                                     setPage(page);
//                                 }}
//                                 perPage={perPage}
//                             />
//                         </div>
//                     </>
//                 )}
//             </div>
//         </div>
//     );
// }
// export default SosRemorquagesAdminTable
const react_1 = __importStar(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const CustomPagination_1 = require("../../../Common/CustomPagination");
const Dropdown_1 = __importDefault(require("react-bootstrap/Dropdown"));
const bs_1 = require("react-icons/bs");
const sos_remorquage_api_1 = require("../../../../utils/api/sos-remorquage/sos-remorquage.api");
const Utils_1 = require("../../../../utils/Utils");
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const EmptyAlert_1 = __importDefault(require("../../../Shared/Alerts/EmptyAlert"));
const react_router_dom_1 = require("react-router-dom");
const useWebSocket_1 = __importDefault(require("../../../../hooks/useWebSocket"));
const useRealtimeChannel_1 = __importDefault(require("../../../../hooks/useRealtimeChannel"));
const TreatedButton = ({ id }) => {
    const treateSOSRemorquage = (0, sos_remorquage_api_1.UseTreateSOSRemorquage)(id);
    return (react_1.default.createElement("button", { className: "dropdown-item", onClick: () => treateSOSRemorquage(), style: {
            background: "none",
            border: "none",
            width: "100%",
            textAlign: "left",
            padding: "0.25rem 1.5rem",
        } }, "Traiter"));
};
exports.TreatedButton = TreatedButton;
const ArchiveButton = ({ id }) => {
    const archiveSOSRemorquage = (0, sos_remorquage_api_1.UseArchiveSOSRemorquage)(id);
    return (react_1.default.createElement("button", { className: "dropdown-item", onClick: () => archiveSOSRemorquage(), style: {
            background: "none",
            border: "none",
            width: "100%",
            textAlign: "left",
            padding: "0.25rem 1.5rem",
        } }, "Archiver"));
};
exports.ArchiveButton = ArchiveButton;
const SosRemorquagesAdminTable = ({ search, dateRange, }) => {
    const socket = (0, useWebSocket_1.default)();
    const [page, setPage] = (0, react_1.useState)(1);
    const [perPage, setPerPage] = (0, react_1.useState)(10);
    const { data, isLoading, refetch } = (0, sos_remorquage_api_1.useGetSOSRemorquageListQuery)({
        page,
        limit: perPage,
        word: search,
        date: dateRange,
    });
    (0, useRealtimeChannel_1.default)({
        socket,
        channel: "remorquage",
        event: "new.remorquage",
        onMessage: (data) => {
            console.log("🟢 Nouvelle demande SOS reçue en temps réel:", data);
            refetch();
        },
    });
    const statutFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "statutformatter__wrapper" }, (row === null || row === void 0 ? void 0 : row.status) === "traited" ? (react_1.default.createElement("div", { className: "badge custom-badge-success" }, "Trait\u00E9")) : (row === null || row === void 0 ? void 0 : row.is_archive) === 1 ? (react_1.default.createElement("div", { className: "badge bg-danger custom-badge-in-progress", style: { color: "#ffffff" } }, "Archiv\u00E9")) : (row === null || row === void 0 ? void 0 : row.is_read) === 1 ? (react_1.default.createElement("div", { className: "badge bg-warning custom-badge-in-progress", style: { color: "#ffffff" } }, "Vu")) : (react_1.default.createElement("div", { className: "badge custom-badge-in-progress" }, "Nouveau"))));
    };
    const dateFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "statutformatter__wrapper position-relative" },
            (0, Utils_1.formatDateWithRelativeDay)(cell),
            (row === null || row === void 0 ? void 0 : row.status) === "nouveau" && (row === null || row === void 0 ? void 0 : row.is_archive) === 0 && (react_1.default.createElement("div", { className: "custon-date-indicator" }))));
    };
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "actionformatter__wrapper" },
            react_1.default.createElement(Dropdown_1.default, null,
                react_1.default.createElement(Dropdown_1.default.Toggle, { id: "dropdown-basic" },
                    react_1.default.createElement(bs_1.BsThreeDots, null)),
                react_1.default.createElement(Dropdown_1.default.Menu, null,
                    react_1.default.createElement(exports.TreatedButton, { id: row.id }),
                    react_1.default.createElement(exports.ArchiveButton, { id: row.id }),
                    react_1.default.createElement(react_router_dom_1.NavLink, { className: "dropdown-item", style: {
                            background: "none",
                            border: "none",
                            width: "100%",
                            textAlign: "left",
                            padding: "0.25rem 1.5rem",
                        }, to: `/admin/sos-remorquage/${row === null || row === void 0 ? void 0 : row.slug}` }, "Voir d\u00E9tails")))));
    };
    const positionFormatter = (cell, row) => {
        const googleMapsUrl = `https://www.google.com/maps?q=${row === null || row === void 0 ? void 0 : row.lat},${row === null || row === void 0 ? void 0 : row.long}`;
        return (react_1.default.createElement("a", { href: googleMapsUrl, target: "_blank", rel: "noopener noreferrer", className: "follow-position-link badge bg-success", style: {
                color: "#FFFFFF",
            } }, "Suivre la position"));
    };
    const columns = [
        {
            dataField: "request_datetime",
            text: "Date de la demande",
            formatter: dateFormatter,
            headerStyle: () => ({
                width: "300px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
        {
            dataField: "phone",
            text: "NUMÉRO DE TÉLÉPHONE",
            headerStyle: () => ({
                width: "200px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
        {
            dataField: "lat",
            text: "Position",
            formatter: positionFormatter,
            headerStyle: () => ({
                width: "300px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
        {
            dataField: "status",
            text: "Statut",
            formatter: statutFormatter,
            headerStyle: () => ({
                width: "200px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => ({
                width: "150px",
                whiteSpace: "normal",
                textAlign: "start",
            }),
        },
    ];
    return (react_1.default.createElement("div", { className: "col-lg-12" },
        react_1.default.createElement("div", { className: "admin-table" },
            isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
            !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: (data === null || data === void 0 ? void 0 : data.data) || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9e trouv\u00E9e" })) }),
                react_1.default.createElement("div", { className: "custom-pagination-container" },
                    react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: data === null || data === void 0 ? void 0 : data.count, page: page, onChange: (page, perPage) => {
                            setPerPage(perPage);
                            setPage(page);
                        }, perPage: perPage })))))));
};
exports.default = SosRemorquagesAdminTable;
